import React from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import Home from './pages/Home'
import NavBar from './components/layout/Navbar'
import Footer from './components/layout/Footer'
import { ToastContainer } from 'react-toastify'
import Unauthorized from './pages/Unauthorized'
import TrendPage from "./pages/TrendPage";
import DashboardLayout from "./components/trend/DashboardLayout";
import ProtectedRoutes from './util/ProtectedRoutes'
import DownloadData from "./components/layout/DownloadData";
import UploadData from "./pages/UploadPage";
import SubscriptionExpired from"./context/SubscriptionExpired";

const App = () => {
  const [open, setOpen] = React.useState(false);
  const location = useLocation();
  const hideLayoutRoutes = ["/unauthorized"];
  const shouldHideLayout = hideLayoutRoutes.includes(location.pathname);

  return (
    <>
      {!shouldHideLayout && <NavBar />}
      <DashboardLayout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route path="/subscription-expired" element={<SubscriptionExpired />} />
          <Route element={<ProtectedRoutes />}>
            <Route path="/download" element={<DownloadData />} />
            <Route path="/trends" element={<TrendPage />} />
            <Route path="/upload" element={<UploadData />} />
          </Route>
        </Routes>
      </DashboardLayout>
      {!shouldHideLayout && <Footer />}
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
        draggable
      />
    </>
  );
};

export default App;